import axios from "axios";
import { baseUrl } from "../Common/Constants";
import httpClient from "../Core/http";


class Api {
    getInterruptingAlarmDatas(params: any): Promise<any> {
      
      let url = "alarm/interruptingAlarmDatas";
      const termsobj = {
        country: params.country,
        customerID: params.customerID,
        deviceTypes: params.deviceTypes,
        devicesWithSerial: params.devicesWithSerial,
        alarmText:params.alarmText
      }

      if (params.devicesWithSerial == null){
        termsobj.devicesWithSerial = []
      }
      if (params.deviceTypes == null){
        termsobj.deviceTypes = []
      }

      const terms = JSON.stringify(termsobj) 

      const queryObject = {
            bucketSize: params.bucketSize,
            start: params.start,
            end: params.end,
            terms: terms,
            scope: params.scope 
      }
    
        //only fetch if terms have any value other than null or empty
      
          return  httpClient.get(url, { params: queryObject }).then((response) => {
          return response.data;
        })
                .catch((error) => {
                    throw error;
                    console.log(error);
                });
       
      
  }

  getInterruptingAlarmDatasWithScope(params:any): Promise<any> {
    let url = "alarm/interruptingAlarmDatasWithScope";

    const termsobj = {
      country: params.country,
      customerID: params.customerID,
      deviceTypes: params.deviceTypes,
      devicesWithSerial: params.devicesWithSerial,
      alarmText:params.alarmText
    }

    if (params.devicesWithSerial == null){
      termsobj.devicesWithSerial = []
    }
    if (params.deviceTypes == null){
      termsobj.deviceTypes = []
    }

    const terms = JSON.stringify(termsobj) 

    const queryObject = {
          bucketSize: params.bucketSize,
          start: params.start,
          end: params.end,
          terms: terms,
          scope: params.scope 
    }
  
    //
    //only fetch if terms have any value other than null or empty
        return   httpClient.get(url, { params: queryObject }).then((response) => {
                return response.data;
      })
                .catch((error) => {
                    throw error;
                    console.log(error);
                });
       
    
  }
  
  getAlarmDetails(alarmText:string){
    const queryObject = {
      alarmText:alarmText
    }
    let url =  "alarmText/alarmTextDetails";
      return  httpClient.get(url, { params: queryObject }).then((response) => {
      return response.data;
    })
              .catch((error) => {
                  throw error;
                  console.log(error);
              });
     
  }
  getLocales(): Promise<any> {
    let url =  "alarmText";
      return   httpClient.get<any[]>(url).then((response) => {
            return response.data;
                  })
              .catch((error) => {
              throw error;
              console.log(error);
          });
     
}

}

export const AlarmApi = new Api();